import { create } from 'zustand';

interface BannerLayoutState {
  shouldRemovePadding: boolean;
  setShouldRemovePadding: (value: boolean) => void;
}

export const useBannerLayoutStore = create<BannerLayoutState>((set) => ({
  shouldRemovePadding: false,
  setShouldRemovePadding: (value: boolean) => set({ shouldRemovePadding: value }),
}));
